export default __webpack_public_path__ + "static/media/previous-slide.fd46a393.svg";